"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require("babel-runtime/helpers/get");

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _datePicker = require("@alicd/next/lib/date-picker");

var _datePicker2 = _interopRequireDefault(_datePicker);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localeProvider = require("@alicd/next/lib/locale-provider");

var _localeProvider2 = _interopRequireDefault(_localeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePickerInner = _datePicker2.default.prototype.render.call({
    _getInstance: function _getInstance() {},
    props: {} }).type;

var DatePickerBaseInner = function (_DatePickerInner) {
    (0, _inherits3.default)(DatePickerBaseInner, _DatePickerInner);

    function DatePickerBaseInner(props) {
        (0, _classCallCheck3.default)(this, DatePickerBaseInner);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DatePickerBaseInner.__proto__ || (0, _getPrototypeOf2.default)(DatePickerBaseInner)).call(this, props));

        _this.cruiRefPopup = null;
        _this.focusInput = _this.focusInput.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(DatePickerBaseInner, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.props.inputAutoFocus && !prevState.open && this.state.open) {
                requestAnimationFrame(this.focusInput);
            }
        }
    }, {
        key: "focusInput",
        value: function focusInput() {
            if (this.cruiRefPopup) {
                var input = this.cruiRefPopup.querySelector(".next-date-picker-input input");
                input && input.focus();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var ret = (0, _get3.default)(DatePickerBaseInner.prototype.__proto__ || (0, _getPrototypeOf2.default)(DatePickerBaseInner.prototype), "render", this).call(this);
            return _react2.default.cloneElement(ret, {
                children: _react2.default.cloneElement(ret.props.children, {
                    ref: function ref(v) {
                        _this2.cruiRefPopup = v;
                    }
                })
            });
        }
    }]);
    return DatePickerBaseInner;
}(DatePickerInner);

DatePickerBaseInner.propTypes = (0, _assign2.default)({}, DatePickerInner.propTypes, {
    inputAutoFocus: _propTypes2.default.bool
});
DatePickerBaseInner.defaultProps = (0, _assign2.default)({}, DatePickerInner.defaultProps, {
    inputAutoFocus: true
});


var DatePickerBase = (0, _localeProvider2.default)(DatePickerBaseInner);
DatePickerBase.LOCALE = _datePicker2.default.LOCALE;

exports.default = DatePickerBase;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-date-picker-field@0.0.12@@alicd/crui-date-picker-field/lib/DatePickerMonkey.js
// module id = 615
// module chunks = 0